export const MAX_EVENT_RECORDS = 10000;
export const MAX_EVENT_PAGES = 1000;
